import { CompetitionStageDto, type ProcedureType } from "../../../../autogen/bff-api";
import { isNegotiationWithoutNotice } from "../../../../common/procurement/negotiationWithoutNotice";
import { isDpsCompetition, isTwoStageProcedure } from "../../../../common/procurement/procedure";

// Mirrors the interest route's own guard, which 409s on two-stage. Keyed on the procedure: a system past its
// validity has no stage to key on.
export const entersByInvitation = (event: {
  procedureType?: ProcedureType | null;
  competitionStage?: CompetitionStageDto | null;
}): boolean =>
  (isTwoStageProcedure(event.procedureType) ||
    isDpsCompetition(event.procedureType) ||
    isNegotiationWithoutNotice(event.procedureType)) &&
  event.competitionStage !== CompetitionStageDto.InterestOpen;
